import '../css/app.scss';
import Swiper from 'swiper/bundle';

const headerBurger = document.querySelector('.header__burger');
const headerClose = document.querySelector('.header__nav-close');
const headerNav = document.querySelector('.header__nav');
const menuLinks = document.querySelectorAll('.header__menu a');
const body = document.querySelector('body');

headerBurger.addEventListener('click', () => {
    headerNav.classList.add('open');
    body.classList.add('body-hidden');
});

headerClose.addEventListener('click', () => {
    headerNav.classList.remove('open');
    body.classList.remove('body-hidden');
});

menuLinks.forEach(link => {
    link.addEventListener('click', () => {
        headerNav.classList.remove('open');
        body.classList.remove('body-hidden');
    });
});


document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("load", function () {
        const sections = document.querySelectorAll("[id]");
        const navLinks = document.querySelectorAll(".header__menu a");
        const offset = 75;
        const homeThreshold = 150;

        function activateMenu() {
            let scrollY = window.pageYOffset;
            let currentSectionId = null;

            if (scrollY < homeThreshold) {
                currentSectionId = "home";
            } else {
                sections.forEach(current => {
                    const sectionHeight = current.offsetHeight;
                    const sectionTop = current.offsetTop - offset;
                    const sectionId = current.getAttribute("id");

                    if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
                        currentSectionId = sectionId;
                    }
                });
            }

            navLinks.forEach(link => {
                link.classList.remove("active");

                if (currentSectionId && link.getAttribute("href") === `#${currentSectionId}`) {
                    link.classList.add("active");
                }
            });
        }

        window.addEventListener("scroll", activateMenu);
        activateMenu();
    });
});




const header = document.querySelector('.header');
let scrollPrev = 0;

if (header != null) {
    window.onscroll = function() {
        const scrolled = window.scrollY || document.documentElement.scrollTop;

        if (scrolled > 100) {
            header.classList.add('scroll-style');

        } else {
            header.classList.remove('scroll-style');
        }

        scrollPrev = scrolled;
    }
}


const itemDesc3 = document.querySelector('.how-works__item-3');
const itemMob3 = document.querySelector('.how-works__item-mob3');
const itemBox3 = document.querySelector('.how-works__item-box3');

const itemDesc4 = document.querySelector('.how-works__item-4');
const itemMob4 = document.querySelector('.how-works__item-mob4');
const itemBox4 = document.querySelector('.how-works__item-box4');

if (itemDesc3 !== null && itemMob3 !== null && itemBox3 && itemDesc4 !== null && itemMob4 !== null && itemBox4 !== null) {
    function moveItemBox() {
        if (window.innerWidth <= 992) {
            itemMob3.appendChild(itemBox3);
            itemMob4.appendChild(itemBox4);
        } else {
            itemDesc3.appendChild(itemBox3);
            itemDesc4.appendChild(itemBox4);
        }
    }

    window.addEventListener('load', moveItemBox);

    window.addEventListener('resize', moveItemBox);
}

const testimonialsSlider = new Swiper (".testimonials-slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
        prevEl: ".testimonials-slider__button-prev",
        nextEl: ".testimonials-slider__button-next",
    },

    breakpoints: {
        320: {
            slidesPerView: 1.6,
            spaceBetween: 10
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        1300: {
            slidesPerView: 3,
            spaceBetween: 30
        }
    }
})

document.querySelectorAll('.accordion__list').forEach((faqList) => {
    const questionsItem = faqList.querySelectorAll('.accordion__item');

    if (questionsItem.length > 0) {
        questionsItem.forEach((item) => {
            const title = item.querySelector('.accordion__title');
            const content = item.querySelector('.accordion__content');

            if (title && content) {
                title.addEventListener('click', () => {
                    if (item.classList.contains('open')) {
                        item.classList.remove('open');
                        content.classList.remove('open');
                        title.classList.remove('open');
                        content.style.maxHeight = 0;
                    } else {
                        questionsItem.forEach((faqItem) => {
                            faqItem.classList.remove('open');
                            const faqContent = faqItem.querySelector('.accordion__content');
                            const faqTitle = faqItem.querySelector('.accordion__title');
                            if (faqContent && faqTitle) {
                                faqContent.classList.remove('open');
                                faqTitle.classList.remove('open');
                                faqContent.style.maxHeight = 0;
                            }
                        });
                        item.classList.add('open');
                        title.classList.add('open');
                        content.classList.add('open');
                        content.style.maxHeight = content.scrollHeight + 'px';
                    }
                });
            }
        });
    }
});
